// extracted by mini-css-extract-plugin
module.exports = {"localHeader":"ArticleCrToolPage_localHeader__yH22l","usedCardLegalAdvice":"ArticleCrToolPage_usedCardLegalAdvice__1UHJJ","carToolIntro":"ArticleCrToolPage_carToolIntro__3zEHo"};